<template>
    <div class="indexCont">
        <div class="mainCont"
            v-loading="loading"
            element-loading-text="拼命加载中"
            element-loading-spinner="el-icon-loading">
             <el-button class="gt_back" icon="el-icon-arrow-left" size="small" @click="goBack()">返回</el-button>
            <div class="head">
                <div class="title">本次考试得分：{{paperInfo.fraction}}分</div>
                <div class="detail">
                    <span class="rank">本次考试排名：第{{paperInfo.ranking}}名</span>
                    <span class="useTime">考试用时：{{paperInfo.useTime}}分钟</span>
                    <span class="misItem">错题：{{paperInfo.errorCount}}题</span>
                </div>
            </div>
            <div class="examTitle">{{paperInfo.paperName}}</div>
            <div class="examItem" v-for="(item,index) in itemList" :key="index">
                <div class="eTitle">{{index + 1}}、{{item.questionName}} 【{{item.typeName}}】</div>
                <div class="comItem" v-for="(item2,index2) in item.questionContent" :key="index2">
                    <div v-show="item2.detail || item2.url ? true : false">{{item2.name}}、 {{item2.detail}}</div>
                    <!-- 有url -->
                    <template v-if="item2.url">
                        <img class="comItem_img" :src="$config.baseApi + item2.url" alt="">
                    </template>
                </div>
                <!-- 为1选择过 -->
                <template v-if="item.paperHistoryItem.useFlag == 1">
                    <template v-if="item.paperHistoryItem.rightStatus">
                        <el-button size="small" type="success" class="correct"> 回答正确：{{item.questionAnswer}}</el-button>
                    </template>
                    <template v-else>
                        <el-button size="small" type="danger" class="mistake">回答错误：{{item.paperHistoryItem.optionStr}}</el-button>
                        <el-button size="small" type="success" class="correct">正确答案：{{item.questionAnswer}}</el-button>
                    </template>
                </template>
                <template v-else>
                    <el-button size="small" type="info">未作答</el-button>
                    <el-button size="small" type="success" class="correct">正确答案：{{item.questionAnswer}}</el-button>
                </template>
                <div class="answerAnalysis">解析：{{item.answerAnalysis ? item.answerAnalysis : "暂无解析"}}</div>
                <div class="comBtn" @click="collectBtn(item.questionId)">收藏试题</div>
            </div>
        </div>
         <!-- 移动端显示 -->
        <div class="mobileTest">
           <MobileComNav title="考试结果"></MobileComNav>
        </div>
        <!-- 收藏弹窗 -->
        <el-dialog
            title="提示"
            :visible.sync="centerDialogVisible"
            :width="dialogWidth"
            center>
            <span>是否确定收藏试题</span>
            <span slot="footer" class="dialog-footer">
            <el-button @click="centerDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="collectItem()">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import MobileComNav from "../../../components/mobileHead";
    export default {
        data(){
            return{
                radio: "",
                checkList: [],
                centerDialogVisible:false,
                dialogWidth:"30%",
                paperInfo:{},
                itemList:[],
                loading:true,
                questionId:"",
                operateType:1, //1代表收藏
            }
        },
        components: {
            MobileComNav
        },
        mounted(){
            document.title=this.$route.meta.title;
        },
        methods: {
            goBack(){
                this.$router.push('./alreadyTest?curPage=' + this.curPage)
            },
            collectBtn(questionId){
                this.centerDialogVisible = true;
                this.questionId = questionId
            },
            collectItem(){
                this.centerDialogVisible = false;
                let url = this.$config.baseApi + "/examination/favorite/operate";
                this.$ajax({
                    url: url,
                    method: "post",
                    data:JSON.stringify({
                        questionId:this.questionId,
                        operateType:this.operateType
                    })
                }).then(res => {
                    if (res.code == 1) {
                        this.$message({
                            message:res.msg,
                            type:"success"
                        })
                    }else{
                        this.$message({
                            message:res.msg,
                            type:"error"
                        })
                    }
                }).catch(err => {
                    console.log(err);
                });
            },
            getPaperDetail(){
                let url = this.$config.baseApi + "/examination/paper/history/" + this.paperHistoryId;
                this.$ajax({
                    url: url,
                    method: "get"
                }).then(res => {
                    if (res.code == 1) {
                        this.paperInfo = res.data;
                        let itemList = res.data.questionItemVoList;
                        itemList.sort(function(a,b){  
                            return a.type - b.type;   //排序题目从小到大
                        });
                        this.itemList = itemList;
                        this.loading = false
                    }
                }).catch(err => {
                    console.log(err);
                });
            },
        },
        created(){
            if(this.$IsPc()){
                this.dialogWidth = "80%"
            };
            this.getPaperDetail()
            
        },
        // 通过路由取出参数
        computed: {
            paperHistoryId(){
                return this.$route.query.paperHistoryId ? this.$route.query.paperHistoryId : ""
            },
            curPage(){
                return this.$route.query.curPage ? this.$route.query.curPage : "" 
            }
        }
    }
</script>

<style scoped>
    .mistake.el-button--danger {
        background-color: #fd5234;
        border-color: #fd5234;
    }
    .correct.el-button--success {
        background-color: #d32830;
        border-color: #d32830;
    }
    .mainCont{
        background: #fff;
        padding:0.17rem 0.3rem;
        position: relative;
        min-height: 4rem
    }
    .head,.examTitle{
        text-align: center;
        font-weight: 500;
        font-size: 0.2rem;
    }
    .examTitle{
        margin-top:0.2rem;
    }
    .head{
        border-bottom: 2px dashed #ccc;
    }
    .head .detail{
        font-size: 0.16rem;
        margin:0.1rem 0 0.17rem;
    }
    .head .rank,.head .useTime{
        margin-right: 0.15rem
    }
    .head .rank{
        color: rgba(255, 141, 26, 1)
    }
    .gt_back{
        position: absolute;
        top:0.17rem;
    }
     .mobileTest{
        display: none;
        margin-top: 1.2rem;
    }
    /* 题目样式 */
    .mainCont .examItem .el-radio,.mainCont .examItem .el-checkbox{
        display: block;
        margin:0.1rem 0;
    }
    .el-radio__label {
        font-size: 0.16rem;
    }
    .examItem{
        font-size: 0.16rem;
        margin-bottom: 0.2rem;
    }
    .examItem .eTitle{
        margin-top:0.15rem;
    }
    .comBtn{
        margin-bottom:0.1rem ;
    }
    .answerAnalysis{
        margin:0.1rem 0;
    }
    .eTitle{
        margin-bottom: 0.1rem;
    }
    @media screen and (max-width: 768px) {
        .examTitle{
            background: #fff;
            width: 90%;
            margin:0 auto;
            font-size: 0.4rem;
        }
        .mainCont {
            margin-top:0.9rem;
            box-sizing: border-box;
            background:transparent;
            padding:0;
            min-height: 8rem
        }
        .examItem{
            box-sizing: border-box;
            background: #fff;
            width:90%;
            margin:0 auto;
            padding:0.2rem;
            margin-bottom: 0.4rem;
            font-size: 0.32rem;
        }
        .head{
            background: #fff;
            border-bottom:0; 
            font-size: 0.4rem;
            padding-top:0.2rem;
        }
        .head .detail{
            font-size: 0.32rem;
            padding-bottom:0.2rem;
        }
        .gt_back{
            display: none;
        }
        .mainCont .examItem .el-radio,.mainCont .examItem .el-checkbox{
            margin:0.2rem 0;
        }
        .mobileTest {
            display: block;
        }
        .detail .rank,.detail .userTime,.detail .misItem{
            display: inline-block;
            width: 50%;
            text-align: left;
        }
        .detail .misItem{
            width: 89%;
            margin-top:0.2rem;
        }
        .answerAnalysis{
            margin:0.2rem 0;
        }
        .eTitle{
            margin-bottom: 0.2rem;
        }
    }
</style>
